import { AlertTriangle } from 'lucide-react';

import type { FallbackProps } from 'react-error-boundary';

/**
 * Full-page error fallback rendered by GlobalErrorBoundary when an
 * unhandled exception bubbles up through the React tree.
 */
export function FallbackError(props: FallbackProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-base-200 p-8">
      <div className="card bg-base-100 border border-base-300 w-full max-w-md">
        <div className="card-body items-center gap-4 text-center">
          <div className="rounded-box bg-error/10 p-4 text-error">
            <AlertTriangle className="h-10 w-10" />
          </div>
          <div className="flex flex-col gap-1">
            <h1 className="text-2xl font-bold">Algo salió mal</h1>
            <p className="text-base-content/60 text-sm">
              Ocurrió un error inesperado. Si el problema persiste, contacta a soporte.
            </p>
          </div>
          {props.error instanceof Error && (
            <pre className="bg-base-200 rounded-box w-full overflow-x-auto p-3 text-left text-xs text-error">
              {props.error.message}
            </pre>
          )}
          <button className="btn btn-primary w-full" onClick={props.resetErrorBoundary}>
            Reintentar
          </button>
        </div>
      </div>
    </div>
  );
}
